/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import {useLocation, useNavigate} from 'react-router-dom'
import api from '../../../_metronic/helpers/api'
import axios from 'axios'
import {useDispatch, useSelector} from 'react-redux'
import useUtils from './useUtils'
import {showAlert} from '../../redux/reducers/alertSlice'
import { setTitle } from '../../redux/reducers/mainSlice'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const AddUnit = () => {
  const location = useLocation()
  const locationState = location?.state?.result || null
  const seasonOptions = useSelector((state) => state?.season?.records)
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  dispatch(setTitle('Unit'))

  const [tab, setTab] = useState(1)

  const {fetchLanguages, fetchCohorts} = useUtils()
  let cohortOptions = useSelector((state) => state?.cohort?.records)
  let languageOptions = useSelector((state) => state?.language?.records)

  useEffect(() => {
    fetchLanguages()
    fetchCohorts()
  }, [])

  const unitSchema = Yup.object().shape({
    code: Yup.string().matches(/^[a-zA-Z0-9-_]+$/, 'Code should only be alpha numeric').required('Please enter Unit code'),
    unitName: Yup.string().required('Please enter Unit title'),
    languageId: Yup.string().required('Please select language'),
    cohortId: Yup.string().required('Please select cohort'),
    seasonId: Yup.string().required('Please select Season'),
    bannerImage: Yup.mixed().when('imgUrl', {
      is: (imgUrl) => !imgUrl, // Apply validation if imgUrl is null or empty
      then: Yup.mixed().required('Image is required'), // Image validation is required if imgUrl is null
    }),
    shortDescription: Yup.string().required('Please enter short description'),
    videos: Yup.array().min(1, 'Please add atleast 1 video').required('Please add atleast 1 video'),
    tags: Yup.array().min(1, 'Tags are mandatory').required('Tags are mandatory'),
  })

  const initialValues = locationState
    ? {
        code: locationState?.code || '',
        id: locationState?.id,
        isClone: locationState?.id?false:true,
        isEdit: true,
        unitName: locationState?.name || '',
        cohort: locationState?.cohort?.title ?? (cohortOptions[0]?.title || ''),
        language: locationState?.language?.name ?? (languageOptions[0]?.name || ''),
        cohortId: locationState?.cohortId ?? (cohortOptions[0]?.id || ''),
        languageId: locationState?.languageId ?? (languageOptions[0]?.id || ''),
        bannerImage: null,
        imgUrl: locationState?.imageUrl || null,
        shortDescription: locationState?.description || '',
        title: locationState?.title || '',
        link: locationState?.link || '',
        description: '',
        mediaId: locationState?.mediaId || null,
        videos: locationState?.unitVideo.map((uv) => uv.video) || [],
        tags: locationState?.tag.map((tags) => tags.name) || [],
        status: locationState?.status || null,
        seasonId: locationState?.seasonId ?? '',
        isForBlackforceMember: locationState?.isForBlackforceMember || false,
      }
    : {
        code: '',
        unitName: '',
        cohort: '',
        language: '',
        cohortId:  '',
        languageId: '',
        bannerImage: null,
        shortDescription: '',
        title: '',
        link: '',
        description: '',
        videos: [],
        tags: [],
        status: null,
        isForBlackforceMember: false,
        seasonId: '',
      }

  const updateUnit = async (values, mediaId) => {
    try {
      let data = {
        code: values.code,
        id: values.id,
        name: values.unitName,
        mediaId,
        description: values.shortDescription,
        videos: values.videos,
        tags: values.tags,
        cohortId: values.cohortId,
        languageId: values.languageId,
        status: values.status,
        isForBlackforceMember: values?.isForBlackforceMember, // 
        seasonId: values?.seasonId, //
      }
      const response = await api.patch(`unit/${values.id}`, data)
      if (response?.data?.status) {
        values = {...values, id: data.id}
        dispatch(showAlert({message: 'Unit Updated', variant: 'success'}))
        navigate('/unitlist/preview-unit', {state: {values}})
      }
    } catch (error) {
      console.log('error')
    }
  }

  const createUnit = async (values, mediaId) => {
    try {
      let data = {
        code: values.code,
        name: values.unitName,
        mediaId,
        description: values.shortDescription,
        videos: values.videos,
        tags: values.tags,
        cohortId: values.cohortId,
        languageId: values.languageId,
        isForBlackforceMember: values?.isForBlackforceMember, // 
        seasonId: values?.seasonId, //
      }
      const response = await api.post(`/unit`, data)
      if (response?.data?.status === 'success') {
        if(values.isClone){
        dispatch(showAlert({message: 'Unit Cloned', variant: 'success'}))
        navigate('/unitlist')
        }else{
          values = {...values, id: response?.data?.data.id, status: null}
          dispatch(showAlert({message: 'Unit Created', variant: 'success'}))
          navigate('/unitlist/preview-unit', {state: {values}})
        }
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const uploadImage = async (values) => {
    if(values.mediaId){
      const {mediaId, ...rest} = values
      createUnit(rest, mediaId)
    }else{
    try {
      const uniqueFileName = `file_${Date.now()}`
      const imageFile = values.bannerImage
      const fileType = imageFile.type
      const fileSize = `${imageFile.size}`

      const uploadDetails = {
        fileName: uniqueFileName,
        fileType: fileType,
        size: fileSize,
      }

      const uploadResponse = await api.post('s3/upload-url', uploadDetails)

      const {mediaId, signedUrl} = uploadResponse.data.data

      const imageUploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
          'Content-Type': fileType,
        },
      })
      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed')
      }
      createUnit(values, mediaId)
    } catch (error) {
      console.log('Error uploading image:', error, error.message)
    }
  }
  }

  const handleSubmit = async (values) => {
    if (values.isEdit && !values.isClone) {
      if (values.mediaId) {
        try {
          let data = {
            id: values.id,
            code: values.code,
            name: values.unitName,
            mediaId: values.mediaId,
            description: values.shortDescription,
            videos: values.videos,
            tags: values.tags,
            cohortId: values.cohortId,
            languageId: values.languageId,
            isForBlackforceMember: values?.isForBlackforceMember, // 
            seasonId: values?.seasonId, //
          }
          const response = await api.patch(`unit/${values.id}`, data)
          if (response.data.status) {
            dispatch(showAlert({message: 'Unit updated', variant: 'success'}))
            navigate('/unitlist/preview-unit', {state: {values}})
          }
        } catch (error) {
          dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
        }
      } else {
        try {
          const uniqueFileName = `file_${Date.now()}`
          const imageFile = values.bannerImage
          const fileType = imageFile.type
          const fileSize = `${imageFile.size}`

          const uploadDetails = {
            fileName: uniqueFileName,
            fileType: fileType,
            size: fileSize,
          }


          const uploadResponse = await api.post('s3/upload-url', uploadDetails)

          const {mediaId, signedUrl} = uploadResponse.data.data

          const imageUploadResponse = await axios.put(signedUrl, imageFile, {
            headers: {
              'Content-Type': fileType,
            },
          })
          if (imageUploadResponse.status !== 200) {
            throw new Error('Image upload failed')
          }
          updateUnit(values, mediaId)
        } catch (error) {
          console.log('Error uploading image:', error, error.message)
        }
      }
    } else {
      uploadImage(values)
    }
  }

  const getTabFields = (tab) => {
    switch (tab) {
      case 1:
        return [
          'code',
          'unitName',
          'languageId',
          'cohortId',
          'bannerImage',
          'shortDescription',
          'isForBlackforceMember',
          'seasonId'
        ]
      case 2:
        return ['videos']
      case 3:
        return ['tags']
      default:
        return []
    }
  }

  const handleTab = async (validateField, errors, setTouched, validateForm, num) => {
    if (num < tab) {
      setTab(num)
    } else if (num - tab === 1) {
      const tabFields = getTabFields(tab)

      const validationErrors = await validateForm()

      const errorsInTab = Object.keys(validationErrors).filter((field) => tabFields.includes(field))

      if (errorsInTab.length === 0) {
        setTab(num)
      } else {
        setTouched(
          tabFields.reduce((acc, field) => {
            acc[field] = true
            return acc
          }, {})
        )
      }
    }
  }
  const handleNextTab = async (validateField, errors, setTouched, validateForm) => {
    const tabFields = getTabFields(tab)

    const validationErrors = await validateForm()

    const errorsInTab = Object.keys(validationErrors).filter((field) => tabFields.includes(field))

    if (errorsInTab.length === 0) {

      setTab(tab + 1)
    } else {
      setTouched(
        tabFields.reduce((acc, field) => {
          acc[field] = true
          return acc
        }, {})
      )
    }
  }

  return (
    <>
     <Formik initialValues={initialValues} validationSchema={unitSchema} onSubmit={handleSubmit}>
          {({
        values,
        touched,
        validateField,
        setTouched,
        handleChange,
        errors,
        handleBlur,
        handleSubmit,
        setFieldValue,
        validateForm,
      }) => (
        <div className='card card-custom'>
          <div className='card-header card-header-stretch overflow-auto'>
            <ul
              className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
              role='tablist'
            >
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 1})}
                  onClick={() => handleTab(validateField, errors, setTouched, validateForm, 1)}
                  role='tab'
                >
                  Create Unit
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 2})}
                  onClick={() => handleTab(validateField, errors, setTouched, validateForm, 2)}
                  role='tab'
                >
                  Videos
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 3})}
                  onClick={() => handleTab(validateField, errors, setTouched, validateForm, 3)}
                  role='tab'
                >
                  Tags
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 4})}
                  onClick={() => handleTab(validateField, errors, setTouched, validateForm, 4)}
                  role='tab'
                >
                  Preview
                </a>
              </li>
            </ul>
          </div>

          <form className='form' onSubmit={handleSubmit}>
            {/* begin::Body */}
            <div className='card-body'>
              <div className='tab-content pt-3'>
                <div className={clsx('tab-pane', {active: tab === 1})}>
                <Tab1
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                    handleChange={handleChange}
                  />
                </div>

                <div className={clsx('tab-pane', {active: tab === 2})}>
                  <Tab2
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                    handleChange={handleChange}
                  />
                </div>

                <div className={clsx('tab-pane', {active: tab === 3})}>
                  <Tab3
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                    handleChange={handleChange}
                  />
                </div>

                <div className={clsx('tab-pane', {active: tab === 4})}>
                  <Tab4
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                    handleChange={handleChange}
                  />
                </div>
              </div>
            </div>
            {/* end::Body */}
            <div className='d-flex align-items-center justify-content-end my-5'>
              <button
                type='button'
                onClick={() => {
                  setTab((prev) => prev - 1)
                  validateForm()
                }}
                disabled={tab === 1}
                className='btn btn-primary ms-2 mt-2 me-2'
              >
                Back
              </button>

              {tab <= 3 && (
                <button
                  type='button'
                  onClick={() => handleNextTab(validateField, errors, setTouched, validateForm)} // Pass formik object to handleNextTab
                  className='btn btn-primary ms-2 mt-2 me-2'
                >
                  Next
                </button>
              )}

              {tab === 4 && (
                    <button
                    type='button' // Prevent default form submission
                    className='btn btn-primary ms-2 mt-2 me-2'
                    onClick={() => {
                      if(values.isClone) {
                        document.querySelector('form')?.requestSubmit() 
                      }
                      else if (values?.isEdit) {
                        setIsOpen(true) // Open the confirmation modal
                      } else {
                        document.querySelector('form')?.requestSubmit() // Directly submit in create mode
                      }
                    }}
                  >
                  {values.isClone?'Clone':values?.isEdit ? 'Update' : 'Create'} 
                  </button>
              )}
            </div>
          </form>

          {/* end::Form */}
        </div>
      )}
    </Formik>
    <AssignConfirmation
            isVisible={isOpen}
            message='Are you sure you want to update this Unit?'
            onConfirm={() => {
              setIsOpen(false)
              setTimeout(() => {
                document.querySelector('form')?.requestSubmit() // Submit the form after modal confirmation
              }, 0)
            }}
            onCancel={() => setIsOpen(false)}
          />
    </>
  )
}

export default AddUnit
